<svg width="12" height="12" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 11.2V9.6L9.26316 5.6V1.2C9.26316 0.536 8.69895 0 8 0C7.30105 0 6.73684 0.536 6.73684 1.2V5.6L0 9.6V11.2L6.73684 9.2V13.6L5.05263 14.8V16L8 15.2L10.9474 16V14.8L9.26316 13.6V9.2L16 11.2Z" fill="#000000" />
</svg>